import { gql } from "@apollo/client";
import { buId } from "../constant";

const GET_USER = gql`
  query getUser($fid: String) {
    getUser(user_id: $fid) {
      user_id
      name
      Role {
        id
        name
        permissions
      }
    }
  }
`;

const GET_ALL_EDITORS = gql`
  query findUsersByUserRole(
    $role: Int
    $tenant: String
    $page: Int
    $size: Int
  ) {
    findUsersByUserRole(
      role: $role
      tenant: $tenant
      page: $page
      size: $size
    ) {
      totalPages
      totalElements
      content {
        request_id
        name
        user_id
        mobile_no
        email_id
        status
        user_profile
        user_role
        reason
        remarks
        created_on
        modified_on
        created_by
        modified_by
      }
    }
  }
`;

const GET_ALL_MODELS = gql`
  {
    getModelMasters(where: { tenant_id: { eq: ${buId} } },first:10000) {
      nodes {
        model_Id
        mODEL_NAME
      }
    }
  }
`;

export { GET_USER, GET_ALL_MODELS, GET_ALL_EDITORS };
